import { useNotificationEvents } from "./composables/use-notification-events";
import { handleNotificationEvent } from "./handle-notification-event";

const workerOptions: WorkerOptions = {
    type: "module",
    name: "Notifications worker",
};

export const registerNotificationsWorker = async () => {
    if (environment.isInAppView) return;

    if (window.SharedWorker) {
        try {
            const worker = new SharedWorker(
                new URL("../../../../../libs/websocket/_notifications-shared-worker.ts", import.meta.url),
                workerOptions
            );
            useNotificationEvents(worker.port, handleNotificationEvent);
        } catch (err) {
            console.error(err);
        }
    } else if (window.Worker) {
        try {
            const worker = new Worker(
                new URL("../../../../../libs/websocket/_notifications-dedicated-worker.ts", import.meta.url),
                workerOptions
            );
            useNotificationEvents(worker, handleNotificationEvent);
        } catch (err) {
            console.error(err);
        }
    } else console.warn("No worker support!");
};
